import ApiRouteProvider from '../route'
import axios from '@axios'

const baseUrl = () => ApiRouteProvider.getBaseUrl()

export default {
    getCatalog(manifestType, ownerContext) {
        return axios.get(
            `${baseUrl()}/import-manifest-contexts/${encodeURIComponent(manifestType)}/catalog`,
            {params: {ownerContext}}
        )
    },

    resolveMappingRequirements(manifestType, payload) {
        return axios.post(
            `${baseUrl()}/import-manifest-contexts/${encodeURIComponent(manifestType)}/mapping-requirements`,
            payload
        )
    },

    create(payload) {
        return axios.post(`${baseUrl()}/import-manifests`, payload)
    },

    list(filters = {}) {
        return axios.get(`${baseUrl()}/import-manifests`, {params: filters})
    },

    get(id) {
        return axios.get(`${baseUrl()}/import-manifests/${id}`)
    },

    update(id, payload) {
        return axios.patch(
            `${baseUrl()}/import-manifests/${id}`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/merge-patch+json',
                },
            }
        )
    },

    createVersion(manifestId, definition) {
        return axios.post(
            `${baseUrl()}/import-manifests/${manifestId}/versions`,
            {definition}
        )
    },

    listVersions(manifestId) {
        return axios.get(`${baseUrl()}/import-manifests/${manifestId}/versions`)
    },

    getVersion(manifestId, versionId) {
        return axios.get(
            `${baseUrl()}/import-manifests/${manifestId}/versions/${versionId}`
        )
    },

    activateVersion(manifestId, versionId) {
        return axios.post(
            `${baseUrl()}/import-manifests/${manifestId}/versions/${versionId}/activate`,
            {}
        )
    },

    outdate(id) {
        return axios.post(`${baseUrl()}/import-manifests/${id}/outdate`, {})
    },

    uploadSourceFile(file) {
        const form = new FormData()
        form.append('file', file)

        return axios.post(`${baseUrl()}/import-source-files`, form)
    },

    inspectSource(fileReferenceId, sampleRowLimit = 5) {
        return axios.post(`${baseUrl()}/import-source-inspections`, {
            fileReferenceId,
            sampleRowLimit,
        })
    },

    createControlRun(manifestId, fileReferenceId, rows = 'all') {
        return axios.post(
            `${baseUrl()}/import-manifests/${manifestId}/control-runs`,
            {fileReferenceId},
            {params: {rows}}
        )
    },

    startImportJob(controlRunId) {
        return axios.post(`${baseUrl()}/import-jobs`, {controlRunId})
    },

    listImportJobs(filters = {}) {
        return axios.get(`${baseUrl()}/import-jobs`, {params: filters})
    },

    getImportJob(id) {
        return axios.get(`${baseUrl()}/import-jobs/${id}`)
    },
}
